import { render, staticRenderFns } from "./ScreenTabFilterByTagsControl.vue?vue&type=template&id=54c276e3&"
import script from "./ScreenTabFilterByTagsControl.vue?vue&type=script&lang=js&"
export * from "./ScreenTabFilterByTagsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports